import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { INSPECTOR_PORTAL_ROUTE } from '@core/authentication/auth.models';
import { AuthService } from '@core/authentication/auth.service';
import { isInspectorUser } from '@core/authentication/auth.utility';

export const redirectInspectorsGuardFn: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return isInspectorUser(auth.userRoles) ? router.parseUrl(INSPECTOR_PORTAL_ROUTE) : true;
};

export const inspectorPortalGuardFn: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.userAuthorized()) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }
  return isInspectorUser(auth.userRoles) ? true : router.parseUrl(auth.mapRoutes());
};
